import React from "react";
import { Grid, Typography} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { SubArea } from "./SubArea";

const useStyles = makeStyles({
    root:{
        padding: 20,
        background:'#212121'
    },
    rootTitulo:{
        color: 'white',
        marginBottom: 10,
        textAlign: "center"
    },
    TypographyRoot:{
        color:'white'
    },
    switchBase:{
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#4CAF50',
            '& + $track': {
              backgroundColor: '#3E8040',
              opacity: 1,
              border: 'none',
            },
          },
    },
    switchBase2:{
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#ffee58',
            '& + $track': {
              backgroundColor: '#B7A931',
              opacity: 1,
              border: 'none',
            },
          },
    },
    checked:{},
    track: {},
    swithColorPrimary:{
        color: 'yellow'
    }
});



export const SubAreasContrataciones = ({title}) => {
    const classes = useStyles();
    const { items, subAreaUsuarioSeleccionado } = useSelector((state) => state.subAreasContrataciones);
    const { idUsuario: idUsuarioSel } = useSelector((state) => state.usuarios.usuarioSeleccionado);
  
    const subAreas = items.map( i => {
    const tieneSubArea = subAreaUsuarioSeleccionado.find( s => s.idSubArea === i.idSubArea );

    return {
        idSubArea: i.idSubArea,
        idUsuario: idUsuarioSel,
        descripcionSubArea: i.descripcion,
        seleccionado: tieneSubArea ? true : false,
        idUsuarioSubArea: tieneSubArea ? tieneSubArea.idUsuarioSubArea : null,
    }})

  return (
    <>
      <Typography component="h3" variant="h5" className={classes.rootTitulo}>{title}</Typography>
      {
        items&&
        <Grid item xs={12} >
            <Grid container item alignItems="center" className={classes.root} >
                {
                    subAreas.map(i => 
                        <SubArea
                            key={i.idSubArea}
                            idSubArea={i.idSubArea}
                            idUsuario={i.idUsuario}
                            seleccionado={i.seleccionado}
                            descripcion={i.descripcionSubArea}
                            idCombinado={i.idUsuarioSubArea}
                        />
                    )
                }
            </Grid>
        </Grid>
      }
    </>
  );
};
